import axios, { AxiosRequestConfig, AxiosPromise, Method } from 'axios';
import { message } from 'antd';
import qs from 'qs';
import CRC32 from 'crc-32';
import { signVerifiy } from './signVerify';
// import { loginOptions } from '../utils/utils';
// import jdLoginTools_create_by_team_aris from '../utils/login';
import { responseSgmReport, responseErrorSgmReport } from "@jdh/interceptors-use";
axios.interceptors.response.use(responseSgmReport, responseErrorSgmReport)
axios.interceptors.request.use(async (config: any) => {
  console.log({...config, data: qs.parse(config.data)});
  try {

    let configBak = config.data;
    if (config.method.toLowerCase() === 'post') {
      const contentType = config.headers['Content-Type'].toLowerCase();
      if (contentType === 'application/json') {
        configBak = JSON.parse(config.data);
      } else if (contentType === 'application/x-www-form-urlencoded') {
        configBak = qs.parse(config.data);
      }
    }
    console.log(configBak, config);
    const res: any = await signVerifiy({...config, data: configBak});
    if (config.method.toLowerCase() === 'post') {
      const contentType = res.headers['Content-Type'].toLowerCase();
      if (contentType === 'application/json') {
        res.data = JSON.stringify(res.data);
      } else if (contentType === 'application/x-www-form-urlencoded') {
        res.data = qs.stringify(res.data);
      }
    }
    console.log(res);
    return res;
  } catch (e) {
    return config
  }
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});
/** 服务端的返回格式 */
export interface AppResponse<T> {
  /** 返回码，请求成功则返回"0000"，失败则返回对应的错误码 */
  code: string;
  /** 返回消息，请求成功返回"OK"，失败则返回对应的错误消息 */
  msg: String;
  /** 请求是否成功 */
  success: boolean;
  /** 返回数据，有可能不存在，也有可能为null */
  data: T | undefined | null;
}

/** color网关的返回格式 */
export interface ColorResponse {
  /** 只有echo字段存在时， 才是API网关返回的熔断响应 */
  echo: string;
  /** 字段含义见： http://color.jd.com/help/faq/code */
  code: string;
}

/**
 * [getQueryString 根据键值获取url后面的参数值]
 * @return {[type]} [参数值]
 */
/* function getUrlParamByKey(name: string) {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i');
  const r = window.location.search.substr(1).match(reg);
  if (r != null) return decodeURI(r[2]);
  return null;
} */

const appid = 'content-client';

let baseUrl = process.env.REACT_APP_ENV === 'development' ? process.env.REACT_APP_BASE_URL_YUFA : process.env.REACT_APP_BASE_URL;

baseUrl = baseUrl?.endsWith('/') ? baseUrl : `${baseUrl}/`;
const url = `${baseUrl}api`;
const getUrlToken = (name: any) => {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
  const r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  }
  return null;
};

/** 构造参数 */
const buildPayload = (functionId: string, method: Method, param?: Object, urlStr?: any, appId?: string) => {
  // const tenantUnid = param && (param as any).tenantUnid ? (param as any).tenantUnid : getUrlToken('tenantUnid');
  // const appUnid = param && (param as any).appUnid ? (param as any).appUnid : getUrlToken('appUnid');
  const erpOrJdpin = window.sessionStorage.getItem('logintype');
  const params = {
    ...param,
  };
  const payload = {
    functionId,
    body: JSON.stringify(params || {}),
    appid: appId || appid,
  };

  const options: AxiosRequestConfig = {
    method,
    // Q：为什么在url里加上了functionId?
    // A：避免调试的时候在network看不出到底发了什么请求
    url: urlStr ? urlStr : `${url}?functionId=${functionId}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    withCredentials: true,
  };

  if (method === 'GET') {
    options.params = payload;
  } else if (method === 'POST') {
    const contentType = options.headers['Content-Type'].toLowerCase();
    if (contentType === 'application/json') {
      options.data = JSON.stringify(payload);
    } else if (contentType === 'application/x-www-form-urlencoded') {
      options.data = qs.stringify(payload);
    }
  }

  return options;
};

export const request = <R, Q = {}, b = any>(functionId: string, method: Method, param?: Q, urlStr?: b, appid?: string) => {
  const options = buildPayload(functionId, method, param, urlStr, appid);
  const req: AxiosPromise<AppResponse<R> | ColorResponse> = axios(options);
  return req
    .then((res) => {
      // console.log(functionId, res)
      // 需要Http异常判断的在这里继续写吧
      let data = res.data || {};
      if ('echo' in data) {
        // color网关报错
        return Promise.reject(data);
      }
      if (data.code == '0000') {
        return data.data;
      }
      if ('success' in data) {
        // 服务端返回正常数据
        if (!data.success) {
          return Promise.reject(data);
        }
        return data.data;
      }
      // 异常数据
      return Promise.reject(res.data);
    }).catch((err) => {
      // 没有登录
      return Promise.reject(JSON.stringify(err));
    });
};

export const post = <R, Q = {}, b = ''>(functionId: string, param?: Q, urlStr?: b, appid?: string) =>
  request<R>(functionId, 'POST', param, urlStr, appid);
export const get = <R, Q = {}>(functionId: string, param?: Q) =>
  request<R>(functionId, 'GET', param);

export function uploadFile(file: File, onUploadProgress?: any) {
  const promise = new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onload = async (event) => {
      const crc = CRC32.bstr(event?.target?.result as string);
      const keycode = `${crc.toString(16)}${file.size}_`;
      axios({
        method: 'POST',
        url: `${process.env.REACT_APP_ENV === 'development' ? process.env.REACT_APP_ARISGW_BASE_URL_YUFA : process.env.REACT_APP_ARISGW_BASE_URL}imageUpload.action`,
        data: file,
        headers: {
          'content-type': file.type,
          keycode,
        },
        onUploadProgress,
      })
        .then((data) => {
          resolve(data.data[0].msg);
        })
        .catch((error) => {
          reject(error);
        });
    };
  });

  return promise;
}
